import { render, staticRenderFns } from "./ordered-item.vue?vue&type=template&id=4a9f8bf7&scoped=true&"
import script from "./ordered-item.vue?vue&type=script&lang=js&"
export * from "./ordered-item.vue?vue&type=script&lang=js&"
import style0 from "./ordered-item.vue?vue&type=style&index=0&id=4a9f8bf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9f8bf7",
  null
  
)

export default component.exports